module.exports = __webpack_public_path__ + "img/2.370409f2.jpg";